import React from "react";
import PropTypes from "prop-types";
// Limitless imports
import { useAppConfig } from "@limitless/common/hooks";
import { useExpertProfileContext } from "../../../../../../expert";
import { phoneNumberIsInternationalFormat } from "@limitless/portal/utils";
import Typography from "@limitless/modern/data-display/typography/Typography";
import Grid from "@limitless/modern/layout/Grid";
import { useMFASetupContext } from "../../../../../hooks/mfa-setup/MFASetupContext";
import Button from "@limitless/modern/inputs/button/Button";
import Dialog from "@limitless/modern/feedback/dialog/Dialog";
import DialPrefixWithPhoneInput from "@limitless/modern/inputs/dial-prefix-with-phone-input/DialPrefixWithPhoneInput";
const MfaPhoneInput = ({
  mfaState,
  setMfaState,
  isEditMobileNoAccess
}) => {
  const {
    profile
  } = useExpertProfileContext();
  const {
    validateMfaSMS,
    validateMfaEmail
  } = useMFASetupContext();
  const {
    config: {
      dialCodes
    }
  } = useAppConfig();
  const [showDialog, setShowDialog] = React.useState(false);
  const phoneIsValid = React.useMemo(() => phoneNumberIsInternationalFormat(mfaState.phoneNumber, dialCodes), [mfaState.phoneNumber]);
  const phoneSubmitClick = () => {
    if (!mfaState.isEmailVerifyed) {
      setMfaState({
        ...mfaState,
        loading: true,
        mfaStepIndex: mfaState.mfaStepIndex > 0 && 0
      });
      validateMfaEmail(null, mfaState, updatedState => setMfaState(updatedState));
    } else {
      setShowDialog(true);
    }
  };
  const onOkSubmit = () => {
    setMfaState({
      ...mfaState,
      loading: true,
      mfaStepIndex: mfaState.mfaStepIndex > 0 && 0
    });
    validateMfaSMS(mfaState, updatedState => setMfaState(updatedState));
  };
  const renderPhoneInputAdornment = /*#__PURE__*/React.createElement(Typography, {
    color: "primary",
    variant: "body",
    sx: {
      cursor: "pointer"
    },
    onClick: phoneSubmitClick
  }, "Edit");
  const renderMFA = React.useMemo(() => {
    return /*#__PURE__*/React.createElement(DialPrefixWithPhoneInput, {
      handlePhoneInputChange: (dialCodeValue, phoneNumberValue) => {
        setMfaState({
          ...mfaState,
          phoneNumber: dialCodeValue + phoneNumberValue
        });
      },
      id: "mfaSecurityPhoneInputField",
      label: mfaState !== null && mfaState !== void 0 && mfaState.editPhoneScreen ? "Trusted phone number" : "",
      value: mfaState.phoneNumber,
      disabled: mfaState === null || mfaState === void 0 ? void 0 : mfaState.editPhoneScreen,
      endAdornment: (mfaState === null || mfaState === void 0 ? void 0 : mfaState.editPhoneScreen) && isEditMobileNoAccess && renderPhoneInputAdornment
    });
  }, [mfaState.phoneNumber]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 9
  }, !mfaState.editPhoneScreen && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    sx: {
      color: theme => theme.palette.grey[4]
    }
  }, !mfaState.isEmailVerifyed ? "Please enter your phone number below:" : "Please update your new phone number below:")))), /*#__PURE__*/React.createElement(Grid, {
    mt: theme => theme.spacing(-0.8)
  }, renderMFA), !(mfaState !== null && mfaState !== void 0 && mfaState.editPhoneScreen) && /*#__PURE__*/React.createElement(Grid, {
    mt: theme => theme.spacing(0.7)
  }, /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    variant: "contained",
    onClick: phoneSubmitClick,
    disabled: mfaState.submitPhoneScreen && !phoneIsValid || !mfaState.submitPhoneScreen || mfaState.loading,
    id: "mfaPhoneInputVerifyButton"
  }, "Verify")), mfaState.errTxt && mfaState.errTxt !== "" && /*#__PURE__*/React.createElement(Grid, {
    mt: theme => theme.spacing(1.5),
    container: true,
    direct: "row",
    alignItems: "center"
  }, mfaState.errTxt.includes("Operation not authorized") ? /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    sx: {
      color: theme => theme.palette.error.dark
    }
  }, "Phone number not verified, please sign in again to verify") : /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    sx: {
      color: theme => theme.palette.error.dark
    }
  }, mfaState.errTxt)), showDialog && /*#__PURE__*/React.createElement(Dialog, {
    open: true,
    title: "Number confirmation:",
    onOkClick: onOkSubmit,
    onClose: () => setShowDialog(false),
    onCancelClick: () => setShowDialog(false),
    okText: "Yes",
    cancelText: "No, I'd like to edit the number",
    paperStyle: {
      maxWidth: "478px"
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, mfaState.phoneNumber), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    sx: {
      mt: 1
    }
  }, "Is the phone number above correct?")));
};
export default MfaPhoneInput;
MfaPhoneInput.propTypes = {
  mfaState: PropTypes.object,
  setMfaState: PropTypes.func,
  isEditMobileNoAccess: PropTypes.bool
};